import React from 'react';
import { breakpoints } from '../config';

const AlertIcon = ({ size = 30, color = 'currentColor' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 30 30">
    <path
      fill={color}
      d="M24.625 26.656c1.417 0 2.484-.614 3.203-1.843.719-1.23.724-2.459.016-3.688L17.28 2.656c-.25-.437-.583-.765-1-.984-.416-.219-.843-.328-1.281-.328-.438 0-.865.11-1.281.328-.417.219-.75.547-1 .984L2.156 21.125c-.708 1.23-.703 2.458.016 3.688.719 1.229 1.786 1.843 3.203 1.843h19.25zm0-1.312H5.375c-.23 0-.443-.032-.64-.094-.199-.063-.391-.146-.579-.25-.166-.104-.323-.23-.468-.375-.146-.146-.271-.302-.376-.469-.104-.166-.182-.349-.234-.547C3.026 23.411 3 23.21 3 23c0-.208.026-.411.078-.61.052-.197.13-.39.235-.578l10.562-18.5c.167-.291.37-.473.61-.546.239-.073.41-.11.515-.11.104 0 .276.037.516.11.24.073.442.255.609.546l10.563 18.5c.104.188.182.38.234.579.052.198.078.4.078.609 0 .208-.026.411-.078.61-.052.197-.13.38-.235.546-.104.167-.229.323-.375.469-.145.146-.302.27-.468.375-.188.104-.38.188-.578.25-.198.063-.412.094-.641.094zm-8.969-6.688v-8h-1.312v8h1.312zM15 22c.27 0 .505-.099.703-.297.198-.198.297-.432.297-.703 0-.27-.099-.505-.297-.703-.198-.198-.432-.297-.703-.297-.27 0-.505.099-.703.297-.198.198-.297.432-.297.703 0 .27.099.505.297.703.198.198.432.297.703.297z"
    />
  </svg>
);

const Alert = ({ message = 'Ocurrió un error al enviar la solicitud.' }) => (
  <div>
    <AlertIcon />
    <span>{message}</span>

    <style jsx>{`
      div {
        position: fixed;
        left: 0;
        right: 0;
        top: 91px;
        background-color: #531e6d;
        color: #fff;
        font-size: 15px;
        padding: 16px 20px;
        display: flex;
        align-items: center;
        animation: alertIn 0.25s ease;
      }

      @media screen and (min-width: ${breakpoints.md}) {
        div {
          z-index: 9998;
          top: 80px;
          justify-content: center;
        }
      }

      @keyframes alertIn {
        from {
          opacity: 0;
          transform: translateY(-100%);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      span {
        margin-left: 16px;
      }
    `}</style>
  </div>
);

export default Alert;
